import { Component } from 'react';
import PropTypes from 'prop-types';
import { getUrlParams, setUrlParams } from '../utils/helper';

/**
 * Reload list based on changing hash
 */
export default class ListComponent extends Component {
  constructor(props) {
    super(props);

    // bind here to pass "this" for event listener
    this.reload = this.reload.bind(this);
    this.gotoPage = this.gotoPage.bind(this);

    this.state = {};
    this.reload();
  }

  componentDidMount() {
    window.addEventListener('hashchange', this.reload, false);
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.reload, false);
  }

  getListParams() {
    const params = {
      limit: this.state.items,
    };
    if (this.state.page !== 1) {
      params.offset = (this.state.page - 1) * this.state.items;
    }
    return params;
  }

  /**
   * Read url parameters and init state, default:
   * keyword: '' (string)
   * page: 1 (number)
   * items: 10 (number)
   */
  initState() {
    if (this.props.location) {
      const urlParams = getUrlParams(this.props.location.search);

      this.state.page = urlParams.page ? +urlParams.page : 1;
      this.state.items = urlParams.items ? +urlParams.items : 12;
    } else {
      this.state.page = 1;
      this.state.items = 999;
    }
  }

  /**
   * Load items depend on current state
   */
  reload() {
    this.initState();

    this.props.loadItems(this.getListParams());
  }

  /**
   * Change items per page and reset page to 1
   *
   * @param ev
   */
  changeItemsPerPage(ev) {
    this.state.page = 1; // reset page
    this.state.items = +ev.target.value;
    this.renderUrl();
  }

  /**
   * Change page to load another portion of items
   *
   * @param pagenum
   */
  gotoPage(pagenum) {
    this.state.page = pagenum;
    this.renderUrl();
  }

  /**
   * Change current url depend on state.
   * This will init reload items, because hash will be changed
   */
  renderUrl() {
    const params = {};
    if (this.state.items !== 10) {
      params.items = this.state.items;
    }
    if (this.state.page !== 1) {
      params.page = this.state.page;
    }

    setUrlParams(params);
  }
}

ListComponent.propTypes = {
  list: PropTypes.arrayOf(PropTypes.object),
  location: PropTypes.objectOf(PropTypes.string),
  loadItems: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/views/ListComponent.js